import { ReactElement } from 'react'
import { Download } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'

interface Props {
  label: string
  loading: boolean
  disabled: boolean
  onClick: () => void
  'data-cy': string
}

const FoundationLoadsDownloadButton = ({
  label,
  loading,
  disabled,
  onClick,
  'data-cy': dataCy,
}: Props): ReactElement => (
  <LoadingButton
    variant="outlined"
    size="small"
    loading={loading}
    disabled={disabled}
    onClick={onClick}
    data-cy={dataCy}
  >
    <Download sx={{ mr: 1 }} />
    {label}
  </LoadingButton>
)

export default FoundationLoadsDownloadButton
